import { useCallback, useEffect, useState } from "react";
import { api, type User } from "@/lib/api";
import { redirectAfterLoginIfNeeded } from "@/lib/authRedirect";

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const u = await api.me();
        if (!cancelled) {
          setUser(u);
        }
      } catch {
        if (!cancelled) {
          setUser(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const loginWithCredentials = useCallback(async (username: string, password: string) => {
    await api.login(username, password);
    const u = await api.me();
    if (!u) {
      throw new Error("Sessão não foi inicializada corretamente. Tente entrar novamente.");
    }
    setUser(u);
    redirectAfterLoginIfNeeded();
    return u;
  }, []);

  const logout = async () => {
    await api.logout();
    window.location.href = "/";
  };

  return {
    user: user || undefined,
    loading,
    isAuthenticated: !!user,
    logout,
    setUser,
    loginWithCredentials,
  };
}
